import AsyncStorage from "@react-native-async-storage/async-storage"
import { clientConfigPath } from "../../config/Constant"
import { setChannelList, setCurrentTv, setIsChannelDataLoading, setIsMediaListLoading, setIsRoomRemoteLoading, setMediaList, setRoomRemoteDetails } from "../Reducers/tvRemoteReducer"
import { setRenderFlashMessage } from "./appConfigAction"
import { getToken } from "../../Apps/tvRemote/helper"

export const fetchChannelList = (scheduleDuration) => {
    return async (dispatch, getState) => {
        try {
            const sessionToken = await AsyncStorage.getItem("sessionToken")
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            let response = await clientConfigPath.post("/Ipg/ChannelData", {
                header: {
                    sessionToken,
                    compressedResponse: "false",
                    scheduleDuration
                },
                payload: {},
            },
            {
                headers: {
                    Authorization: `Bearer ${tvRemotwAuthToken}`
                }
            })

            dispatch(setChannelList(response.data));
        } catch (error) {
            console.log(error)
        } finally {
            dispatch(setIsChannelDataLoading(false))
        }
    }
}


// Check if it correct or not?
export const getremoteAccessToken = (callback) => {
    return async (dispatch, getState) => {
        try {
            // const response = {
            //     payload: {
            //         devices: [
            //             {
            //                 remoteSessionToken: "testRemoteSessionToken",
            //                 deviceName: "Living Room",
            //             },
            //             {
            //                 remoteSessionToken: "testRemoteSessionToken",
            //                 deviceName: "Common Room",
            //                 deviceType: "APPLETV"
            //             }
            //         ]
            //     }
            // }
            // dispatch(setRoomRemoteDetails(response.payload.devices));
            
            const room = await AsyncStorage.getItem("room")
            const sessionToken = await AsyncStorage.getItem("sessionToken")
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            if (room && room !== "null"){
                let response = await clientConfigPath.post("/remote/getRemoteSessionToken", {
                    header: {
                        locationNumber: room
                    },
                    payload: {},
                },
                {
                    headers: {
                        Authorization: `Bearer ${tvRemotwAuthToken}`
                    }
                })

                dispatch(setIsRoomRemoteLoading(false))

                if(!response.data.payload){
                    callback(false);
                    return
                }

                dispatch(setRoomRemoteDetails(response.data.payload.devices));
            
                callback(true);
            }
        } catch (error) {
            console.log(error);
            dispatch(setIsRoomRemoteLoading(false))
            callback(false);
        }
    }
}

export const getMediaStreaming = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(setIsMediaListLoading(true));
            // const response = {
            //     payload: [
            //         {
            //             mediaName: "Netflix",
            //             imageUri: "https://images.ctfassets.net/y2ske730sjqp/1aONibCke6niZhgPxuiilC/2c401b05a07288746ddf3bd3943fbc76/BrandAssets_Logos_01-Wordmark.jpg?w=940",
            //             keyCommand: "netflix"
            //         },
            //         {
            //             mediaName: "Hulu",
            //             imageUri: "https://greenhouse.hulu.com/app/uploads/sites/12/2023/10/networkID-hulu.png",
            //             keyCommand: "hulu"
            //         },
            //         {
            //             mediaName: "Prime Video",
            //             imageUri: "https://images.moneycontrol.com/static-mcnews/2024/07/20240725074952_WhatsApp-Image-2024-07-25-at-12.17.26.jpeg?impolicy=website&width=770&height=431",
            //             keyCommand: "primevideo"
            //         },
            //         {
            //             mediaName: "YouTube",
            //             imageUri: "https://t3.ftcdn.net/jpg/06/34/31/96/360_F_634319630_txtgmPLEEQ8o4zaxec2WKrLWUBqdBBQn.jpg",
            //             keyCommand: "youtube"
            //         }
            //     ]
            // }
            // dispatch(setMediaList(response.payload));
            const room = await AsyncStorage.getItem("room")
            const sessionToken = await AsyncStorage.getItem("sessionToken")
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            const response = await clientConfigPath.post("/worldVue/getApps", {
                header: {
                    locationNumber: room
                },
                payload: {},
            })

            if(!response.data.payload){
                // callback(false);
                dispatch(setRenderFlashMessage(true, { type: "danger", message: "No media streaming devices" }));
                dispatch(setIsMediaListLoading(false));
                return
            }
            dispatch(setMediaList(response.data.payload));
            
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error?.message || "Something went wrong"
            dispatch(setIsMediaListLoading(false));
            dispatch(setRenderFlashMessage(true, { type: "danger", message: errorMessage }))
        }
    }
}

export const mediaStreamingLaunchApp = (token, mediaName, deviceType, callback=() => {}) => {
    return async (dispatch, getState) => {
        try {
            const room = await AsyncStorage.getItem("room");
            const sessionToken = await AsyncStorage.getItem("sessionToken");
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            const response = await clientConfigPath.post("/worldVue/launchApp", {
                header: {
                    "remoteSessionToken": token,
                    "locationNumber": room,
                    "appName": mediaName,
                    deviceType
                },
                payload: {},
            })

            if(response.data?.header?.status?.code === "SUCCESS"){
                callback(true, response.data?.header?.status?.msg);
                return
            } else {
                callback(false, response.data?.header?.status?.msg)
            }
            // dispatch(setMediaList(response.data.payload));
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error?.message || "Something went wrong"
            callback(false, errorMessage)

        }
    }
}



export const getTVRemoteAuthToken = (callback) => {
    return async (dispatch, getState) => {
        try {
            let response = await clientConfigPath.post("/remoteControl/authenticate", {
                payload: {
                    "name":"gj_rapi",
                    "authCode":"4597572ad2bfe858TOC4AhwX08034738433983b8"
                },
            })

            if(!response?.data?.payload){
                callback(false)
                return;
            }
            // dispatch(setRoomRemoteDetails(response.data.payload.token));

            await AsyncStorage.setItem("tvRemotwAuthToken", response.data.payload[0].token)
            callback(true)
        } catch (error) {
            console.log(error)

            if(callback){
                callback(false)
            }
        }
    }
}

export const fetchIPTVChannelList = () => {
    return async (dispatch, getState) => {
        try {
            const room = await AsyncStorage.getItem("room")
            const sessionToken = await AsyncStorage.getItem("sessionToken")
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            if(room && room !== "null"){
                let response = await clientConfigPath.post("/channelList/fetch", {
                    header: {
                        sessionToken,
                        locationNumber: room
                    },
                    payload: {},
                },
                {
                    headers: {
                        Authorization: `Bearer ${tvRemotwAuthToken}`
                    }
                })

                if(response.data){
                    // channelData: responseData.data.channelList,
                    // currentChannel: responseData.data.channelList[0]
                }

            }
            
        } catch (error) {
        }
    }
}


export const validateGuestForTVRemote = (guestName, guestLocation, callback) => {
    return async (dispatch, getState) => {
        try {
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            let response = await clientConfigPath.post("/remoteControl/guest/validate", {
                header: {
                    guestName,
                    location: guestLocation
                },
                payload: {
                    "guestDeviceIP": "",
                    "guestDeviceMac": ""
                },
            },{
                headers: {
                    Authorization: `Bearer ${tvRemotwAuthToken}`
                }
            })

            if(!response?.data){
                callback(false)
                return;
            }
            callback(true)
        } catch (error) {
            console.log(error)

            if(callback){
                callback(false)
            }
        }
    }
}

export const refreshToken = async (dispatch, command) => {
    let maxRetry = 3, status= false;

    while (maxRetry > 0) {
        const response = await new Promise((resolve) => {
            dispatch(getremoteAccessToken((success, roomRemoteDetails) => {
                resolve({success, roomRemoteDetails});
            }));
        });


        if (response?.success) {
            status = true;
            break
        }

        maxRetry--;
    }

    return status
};

export const sendChannelCommand = (token, command) => {
    return async (dispatch, getState) => {
        try {
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            const room = await AsyncStorage.getItem("room")
            let response = await clientConfigPath.post("/worldVue/setChannel", {
                header: {
                    remoteSessionToken: token,
                    "channelNumber": Number(command),
                    "locationNumber": room
                },
                payload: {
                },
            },{
                headers: {
                    Authorization: `Bearer ${tvRemotwAuthToken}`
                }
            })

            console.log(command, " ", response?.data)
        } catch (error) {

        }
    }
}


export const channelApi = (token, command, action) => {
    return async (dispatch, getState) => {
        try {
            const tvRemotwAuthToken = await AsyncStorage.getItem("tvRemotwAuthToken");

            let response = await clientConfigPath.post("/remote/commands", {
                header: {
                    remoteSessionToken: token
                },
                payload: {
                    "capsOn": false,
                    "commands": command,
                    action
                },
            },{
                headers: {
                    Authorization: `Bearer ${tvRemotwAuthToken}`
                }
            })

            console.log(command, " ", response?.data)
        } catch (error) {
            console.log(error);
            const status = error?.response?.status;

            if (status === 400 || status === 401) {
                dispatch(setIsRoomRemoteLoading(true));
                dispatch(setIsChannelDataLoading(true));

                const refreshed = await refreshToken(dispatch, command);
                dispatch(setIsChannelDataLoading(false));

                if (!refreshed) {
                    return dispatch(
                        setRenderFlashMessage(
                            true,
                            { type: "danger", message: "Something went wrong" }
                        )
                    );
                }

            } else {
                dispatch(
                    setRenderFlashMessage(
                        true,
                        { type: "danger", message: "Something went wrong" }
                    )
                );
            }

        }
    }
}